// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["wp-content/themes/fsew/css/main"], () => (__webpack_require__("./wp-content/themes/fsew/js/pre-compiled/main.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["wp-content/themes/fsew/css/main"], () => (__webpack_require__("./wp-content/themes/fsew/scss/main.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
